<template>
  <Row>
    <Col span="12">
      <Input v-model="searchName" placeholder="请输入名称" class="public-inp" />
      <Button
        type="primary"
        icon="md-search"
        @click="getList()"
        >搜索</Button
      >
      <Button @click="resetList()"
        >重置</Button
      >
    </Col>
    <Col span="12">
      <Button
        type="primary"
        icon="md-add"
        class="public-fr"
        @click="openFn()"
        >添加角色</Button
      >
    </Col>
    <Col span="24">
      <Table
        :style="{ marginTop: '10px' }"
        border
        stripe
        :loading="loading"
        :columns="columns"
        :data="tbList"
      >
        <template slot-scope="{ row, index }" slot="status">
          <i-switch
            :value="row.status == 1"
            @on-change="(v) => stateChange(v, row, index)"
            size="small"
          />
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <a
            href="javascript:;"
            @click="menuFn(row)"
            >权限</a
          >
          <a
            href="javascript:;"
            v-if="row.status == 1"
            @click="openFn(row, index)"
            >编辑</a
          >
          <a
            href="javascript:;"
            @click="removeFn(row)"
            >删除</a
          >
        </template>
      </Table>
      <Page
        :total="total"
        :page-size="pageSize"
        :current="page"
        show-sizer
        show-total
        prev-text="上一页"
        next-text="下一页"
        @on-change="pageChange"
        @on-page-size-change="pageSizeChange"
        class="public-page"
      />
    </Col>
    <!-- 编辑 -->
    <Modal
      v-model="formModel"
      :title="formTitle == 0 ? '新增角色' : '编辑角色'"
      :loading="formModalLoading"
      :mask-closable="false"
      @on-ok="addAction"
      @on-cancel="cancelAction"
    >
      <Form
        ref="formValidate"
        :model="formItem"
        :rules="ruleValidate"
        :label-width="80"
      >
        <FormItem label="名称" prop="roleName">
          <Input v-model="formItem.roleName" placeholder="请输入名称"></Input>
        </FormItem>
        <FormItem label="描述">
          <Input
            v-model="formItem.remark"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 5 }"
            placeholder="请输入描述"
          ></Input>
        </FormItem>
      </Form>
    </Modal>
    <!-- 菜单权限 -->
    <Drawer title="菜单权限" @on-close="menuCloseFn" v-model="menuVisible">
      <div class="content">
        <Tree :data="treeData" show-checkbox multiple ref="tree1"></Tree>
      </div>
      <Button @click="handleSave" type="primary" style="margin-right: 10px"
        >提交</Button
      >
      <Button @click="menuCloseFn">取消</Button>
    </Drawer>
  </Row>
</template>
<script>
const columns = [
  {
    title: "角色id",
    key: "code",
  },
  {
    title: "名称",
    key: "roleName",
  },
  {
    title: "更新时间",
    key: "updatetime",
  },
  {
    title: "创建时间",
    key: "createtime",
  },
  {
    title: "状态",
    slot: "status",
  },
  {
    title: "备注",
    key: "remark",
  },
  {
    title: "操作",
    slot: "action",
    width: 150,
  },
];
export default {
  data() {
    return {
      loading: false,
      columns,
      tbList: [],
      searchName: "",
      page: 1,
      pageSize: 10,
      total: 0,
      formModel: false,
      formModalLoading: true,
      formTitle: 0,
      formItem: {
        roleName: "",
        remark: "",
      },
      updateCode: "",
      ruleValidate: {
        roleName: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
      menuVisible: false,
      treeData: [],
      menuRoleCode: "",
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 列表
    getList() {
      let data = {
        roleName: this.searchName,
        page: this.page,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$api.roleSearch(data).then((res) => {
        this.loading = false;
        if (res.code == "200") {
          let list = res.data;
          if (!list || list.length == 0) {
            this.tbList = [];
            return;
          }
          this.tbList = list;
          this.total = res.total;
        }
      });
    },
    // 页码
    pageChange(d) {
      this.page = d;
      this.getList();
    },
    // 页数
    pageSizeChange(d) {
      this.pageSize = d;
      this.getList();
    },
    // 重置
    resetList() {
      this.searchName = "";
      this.page = 1;
      this.pageSize = 10;
      this.$nextTick(() => {
        this.getList();
      });
    },
    // 打开新增编辑
    openFn(d, i) {
      let that = this;
      this.formTitle = d ? 1 : 0;
      if (d) {
        this.formItem = { roleName: d.roleName, remark: d.remark };
        this.updateCode = d.code;
      }
      this.$nextTick(() => {
        that.formModel = true;
      });
    },
    // 新增编辑确定
    addAction() {
      let data = this.formItem;
      let http = "roleAdd";
      this.$refs["formValidate"].validate((valid) => {
        if (valid) {
          if (this.formTitle == 1) {
            data.code = this.updateCode;
            http = "roleUpdate";
          }
          this.$api[http](data).then((res) => {
            if (res.code == "200") {
              this.$Message.success("操作成功");
              this.cancelAction();
              this.getList();
            }
          });
        }
      });
      this.formModalLoading = false;
      this.$nextTick(() => {
        this.formModalLoading = true;
      });
    },
    cancelAction() {
      this.$refs["formValidate"].resetFields();
      this.formModel = false;
    },
    // 删除角色
    removeFn(d) {
      this.$Modal.confirm({
        title: "提示",
        content: `确认删除${d.roleName}`,
        okText: "确定",
        cancelText: "取消",
        onOk: async () => {
          this.$api.roleDelete({ code: d.code }).then((res) => {
            if (res.code == "200") {
              this.$Message.success("删除成功");
              this.getList();
            }
          });
        },
      });
    },
    // 菜单权限
    menuFn(d) {
      this.menuVisible = true;
      this.menuRoleCode = d.code;
      let sl = d.menuCode ? d.menuCode.split(",") : [];
      this.$api.menuAllSearch({}).then((res) => {
        if (res.code == "200") {
          let obj = {
            code: "",
            parent: "-1",
            label: "全部菜单",
            expand: true,
          };
          let tl = [obj, ...res.data];
          let btn_list = tl.filter(
            (item) => item.mType == "2" && sl.indexOf(item.code) != -1
          );
          let btnCode = btn_list.map((item) => {
            return item.parent;
          });
          let list = tl.map((item) => {
            if (item.parent) {
              if (item.mType == "2") {
                item.checked = sl.indexOf(item.code) != -1;
              } else {
                item.checked =
                  sl.indexOf(item.code) != -1 &&
                  btnCode.indexOf(item.code) == -1;
              }
            }
            return item;
          });
          this.treeData = this.arrayToTree(list);
        }
      });
    },
    arrayToTree(list) {
      let cloneList = list.map((item) => {
        return {
          code: item.code,
          parent: item.parent,
          title: item.label,
          checked: item.checked,
          expand: true,
        };
      });
      return cloneList.filter((father) => {
        let branchArr = cloneList.filter(
          (child) => father["code"] == child["parent"]
        );
        branchArr.length > 0 ? (father["children"] = branchArr) : "";
        return father["parent"] == "-1";
      });
    },
    menuCloseFn() {
      this.menuVisible = false;
    },
    handleSave() {
      let d = this.$refs["tree1"].getCheckedAndIndeterminateNodes();
      let list = d.map((item) => {
        return item.code;
      });
      list.shift();
      let data = {
        code: this.menuRoleCode,
        menuCode: list.toString(),
      };
      this.$api["roleMenu"](data).then((res) => {
        if (res.code == "200") {
          this.$Message.success("修改成功");
          this.getList();
          this.menuVisible = false;
        }
      });
    },
    // 状态
    stateChange(v, d, i) {
      let s = d.status == 1 ? "2" : "1";
      let data = {
        code: d.code,
        status: s,
      };
      this.$api["roleStatus"](data).then((res) => {
        if (res.code == "200") {
          this.$Message.success(v ? "启用成功" : "禁用成功");
          this.getList();
        }
      });
    },
  },
};
</script>
<style scoped>
.content {
  height: 70vh;
  overflow-y: scroll;
  margin-bottom: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/basic/roleManagement.vue